import { IconHighlightedSizeType } from '@kubit/web-ui-components/iconHighlighted/types';
import { SelectorRowDecorativeElementTypeEnum } from '../../../../../../components/selectorRowV2/types/decorativeElement';
import { SelectorRowStates } from '../../../../../../components/selectorRowV2/types/state';
import { IconHighlightedVariantType } from '../../variants';
import { commonStyles } from '../commonStyles';
import { SelectorRowVariants } from '../variants';
export const getCustomStyles = (FOUNDATIONS, FONT) => ({
    [SelectorRowVariants.CUSTOM]: {
        [SelectorRowStates.UNSELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_neutral_bg_opacity_00,
                    border_radius: FOUNDATIONS.radius_comp_forms_selectorrow_custom_radiussize,
                },
            }),
        },
        [SelectorRowStates.SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_selected_bg_200,
                    border_radius: FOUNDATIONS.radius_comp_forms_selectorrow_custom_radiussize,
                },
                decorativeElement: {
                    [SelectorRowDecorativeElementTypeEnum.ICON_HIGHLIGHTED]: {
                        variant: IconHighlightedVariantType.CIRCLE,
                        size: IconHighlightedSizeType.EXTRA_SMALL,
                    },
                },
            }),
        },
        [SelectorRowStates.HOVER]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_hover_primary_bg_100,
                    border_radius: FOUNDATIONS.radius_comp_forms_selectorrow_custom_radiussize,
                },
            }),
        },
        [SelectorRowStates.PRESSED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_pressed_primary_bg_200,
                    border_radius: FOUNDATIONS.radius_comp_forms_selectorrow_custom_radiussize,
                },
            }),
        },
        [SelectorRowStates.FILLING]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_neutral_bg_opacity_00,
                    border_radius: FOUNDATIONS.radius_comp_forms_selectorrow_custom_radiussize,
                },
            }),
        },
        [SelectorRowStates.DISABLED_UNSELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    cursor: 'auto',
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    border_radius: FOUNDATIONS.radius_comp_forms_selectorrow_custom_radiussize,
                },
                decorativeElement: {
                    ['ICON']: {
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
            }),
        },
        [SelectorRowStates.DISABLED_SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    cursor: 'auto',
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    border_radius: FOUNDATIONS.radius_comp_forms_selectorrow_custom_radiussize,
                },
                decorativeElement: {
                    ['ICON']: {
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
            }),
        },
    },
});
//# sourceMappingURL=custom.js.map